import React from "react";

export const SnackBar = ({ children, onExited, open }) => {
  return <div className="snackbar bold">{children}</div>;
};
